import { ABTestContextAwareConfigurationValue, BUCKET_FILTER, MULTISELECT_FILTER, } from '@as-react/common-types';
export const getFilterQueryParameter = (filterValue) => `&filter=${encodeURIComponent(filterValue)}`;
// Example: &filter=brand:(171_be;118_be)
export const getMultiFilter = (filter, values) => getFilterQueryParameter(`${filter}:(${values.join(';')})`);
// Example: &filter=product_colour_selling_price0902:[500;1000]
export const getRangeFilter = (filter, min, max) => getFilterQueryParameter(`${filter}:[${min};${max}]`);
// Example: &filter=company_v_in_web:102<company_v_in_web<103
export const getBucketFilter = (filter, value) => getFilterQueryParameter(`${filter}:${value}`);
export const getSelectedFilterAmount = (filter, currentFilters) => {
    if (!currentFilters || !currentFilters[filter.filterOn]) {
        return undefined;
    }
    if (filter.type === MULTISELECT_FILTER) {
        return filter.values.filter(({ active }) => active).length;
    }
    return 1;
};
export const isActiveFilter = (filter, activeFilters) => {
    if (activeFilters && activeFilters[filter.filterOn]) {
        if (filter.type === MULTISELECT_FILTER || filter.type === BUCKET_FILTER) {
            return Boolean(filter.values.some(({ active }) => active));
        }
        return true;
    }
    return false;
};
export const getABEnabledFeatureToggleValue = (featureToggle, abTestCookie) => {
    if (featureToggle === ABTestContextAwareConfigurationValue.ENABLED_WITH_AB_TEST) {
        return abTestCookie !== null && abTestCookie !== void 0 ? abTestCookie : false;
    }
    return featureToggle === 'enabled';
};
